import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { AthleteQuestionnaireLayout } from "src/pages/AthleteQuestionnaireLayout";
import { createPrivateQuestionnairesRepository } from "src/repositories/questionnaires/createPrivateQuestionnairesRepository";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/questionnaires/$questionnaireId",
)({
  component: RouteComponent,
  ssr: true,
  async loader({ context, params }) {
    return loaderHandler(async () => ({
      data: await context.queryClient.query({
        ...createPrivateQuestionnairesRepository().submissionsOptions(
          params.athleteId,
          params.questionnaireId,
          { pageIndex: 0, pageSize: 20 },
        ),
        staleTime: "static",
      }),
    }));
  },
});

function RouteComponent() {
  const { questionnaireId } = Route.useParams();
  return <AthleteQuestionnaireLayout questionnaireId={questionnaireId} />;
}
